import React, { useRef } from 'react';

import classNames from 'classnames';

import { useHasVerticalScrollbar } from '@/shared/hooks';
import type { BadgeItem } from '@/shared/types/badge';
import { BadgeList } from '@/shared/ui/BadgeList';

import styles from './ColumnListScrollBlock.module.css';

type ColumnListScrollBlockProps = {
  items: BadgeItem[];
  highlightQuery: string;
};

export const ColumnListScrollBlock: React.FC<ColumnListScrollBlockProps> = ({ items, highlightQuery }) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const { hasVerticalScroll, scrollbarWidth } = useHasVerticalScrollbar(scrollRef, [items]);

  const blockStyle = (hasVerticalScroll ? { '--scrollbar-width': `${scrollbarWidth}px` } : undefined) as
    | React.CSSProperties
    | undefined;

  return (
    <div className={styles.columnsBlock} style={blockStyle}>
      <div
        className={classNames(styles.columnsTitle, {
          [styles.columnsTitleScrollGutter]: hasVerticalScroll,
        })}>
        컬럼
      </div>
      <div
        ref={scrollRef}
        className={classNames(styles.columnsScroll, {
          [styles.scrollGutterRight]: hasVerticalScroll,
        })}>
        <BadgeList variant="column" highlightQuery={highlightQuery} items={items} showIcon={false} />
      </div>
    </div>
  );
};
